export const buttonSizes = {
   ['Small']: {
      padding: 'py-8px px-8px',
      borderRadius: 'rounded-lg',
      iconSize: {
         width: 20,
         height: 20
      }
   },
   ['Medium']: {
      padding: 'py-10px px-10px',
      borderRadius: 'rounded-lg',
      iconSize: {
         width: 20,
         height: 20
      }
   },
   ['Large']: {
      padding: 'py-10px px-10px',
      borderRadius: 'rounded-10px',
      iconSize: {
         width: 24,
         height: 24
      }
   }
}
